
import * as request from 'superagent';
import { getCurrentUser } from 'helpers/Utils';
import { NotificationManager } from 'components/common/react-notifications';

export const BASE_URL = `${process.env.NODE_ENV !== 'production'
    ? process.env.REACT_APP_DEV
    : process.env.REACT_APP_LIVE
  }`;

// eslint-disable-next-line 
export const isUnauthorizedAccess = function (res) {
  if(res){
    if(Number(res.statusCode) === 401){
      if(res.body && res.body.detail === "Signature has expired."){
        localStorage.setItem('cb_current_user',null);
        window.location.reload();
        NotificationManager.error('Server Error', 'Login session expired!!!', 3000, null, null, '');
      }else{
        NotificationManager.error('Server Error', 'Error occured!!!', 3000, null, null, '');
      }
    }
  }
};

const apiCall = (data, type, url) => {
  const currentUser = getCurrentUser();
  let token = '';
  if (currentUser) {
    token = currentUser.token;
  }
  
  return new Promise((resolve, reject) => {
    request[type](`${BASE_URL}/${url}`)
      .send(data)
      .set('Content-Type', 'application/json')
      .set('authorization', `Bearer ${token}`)
      .end((err, res) => {
        isUnauthorizedAccess(res);
        if (res) {
          return resolve(res.body);
        }
        return reject(err);
      });
  });
}

// Use this API if you require to manupilate entire response at component-level,
// and return guiding steps to handle user journey

// See usage: src/modules/providers/form/ProviderMultiForm
const apiFullCall = (data, type, url) => {
  const currentUser = getCurrentUser();
  let token = '';
  if (currentUser) {
    token = currentUser.token;
  }
  
  return new Promise((resolve, reject) => {
    request[type](`${BASE_URL}/${url}`)
      .send(data)
      .set('Content-Type', 'application/json')
      .set('authorization', `Bearer ${token}`)
      .end((err, res) => {
        isUnauthorizedAccess(res);
        if (res) {
          return resolve(res);
        }
        return reject(err);
      });
  });
};

const apiFileUploadCall = (data,type, url) => (
  new Promise((resolve, reject) => {
    const currentUser = getCurrentUser();
    let token = '';
    if (currentUser) {
      token = currentUser.token;
    }
    request[type](`${BASE_URL}/${url}`)
      .send(data)
      .set('authorization', `Bearer ${token}`)
      .end((err, res) => {
        isUnauthorizedAccess(res);
        if (res) {
          return resolve(res.body);
        }
        return reject(err);
      });
  })
);


export { apiCall, apiFullCall, apiFileUploadCall };